import { render, staticRenderFns } from "./author-apply.vue?vue&type=template&id=3acd51f0&scoped=true&"
import script from "./author-apply.vue?vue&type=script&lang=js&"
export * from "./author-apply.vue?vue&type=script&lang=js&"
import style0 from "./author-apply.vue?vue&type=style&index=0&id=3acd51f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd51f0",
  null
  
)

export default component.exports